import { FC, ReactNode } from 'react'
import styles from './FAQ.module.scss'
import SlideDown from 'components/SlideDown'
import cx from 'classnames'

export interface QA {
	question: string
	answer: ReactNode	
}

export interface FAQProps {
	items: QA[]
	inverted?: boolean
}

export const FAQ: FC<FAQProps> = (props) => {
	return (
		<div className={cx(styles.container, { [styles.inverted]: props.inverted })}>
			<div className={styles.title}>
				<h2>FAQs</h2>
			</div>
			<div className={styles.faqs}>
				{props.items.map((qa, i) => (
					<SlideDown
						top={<p className={styles.question}>{qa.question}</p>}
						key={i}
						className={styles.question_container}
						inverted={props.inverted}
					>
						<span className={styles.answer}>{qa.answer}</span>
					</SlideDown>
				))}
			</div>
		</div>
	)
}
